jQuery(document).ready(function($) {

    var valuationForm = $('.valuation-form');
    var valuationBtn = $('.valuation-btn');
    var valuationBtnText = $('.valuation-btn p');
    var valuationClose = $('.valuation-close');

    var valuationMobileBtn = $('.valuation-btn-mobile');

    valuationBtn.on('click', function() {
        if(valuationForm.hasClass('is-active')) {
            valuationForm.removeClass('is-active');
            valuationBtnText.text('VALUE MY PROPERTY');
        }else{
            valuationForm.addClass('is-active');
            valuationBtnText.text('CLOSE');
        }
    });

    valuationMobileBtn.on('click', function() {

        if(valuationForm.hasClass('is-active')) {
            valuationForm.removeClass('is-active');
            // valuationBtnText.text('GET A VALUATION');
        }else{
            valuationForm.addClass('is-active');
            // valuationBtnText.text('CLOSE');
        }
    });

    valuationClose.on('click', function() {
        valuationForm.removeClass('is-active');
    });

});
